/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Negotiation_Relevant_Scenarios_DetectedInputs */

const en_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const de_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const fr_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const es_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const it_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const nl_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const pl_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const fi_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const da_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

const sv_negotiation_relevant_scenarios_detected = /** @type {(inputs: Negotiation_Relevant_Scenarios_DetectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} relevant scenario(s) detected`)
};

/**
* | output |
* | --- |
* | "{count} relevant scenario(s) detected" |
*
* @param {Negotiation_Relevant_Scenarios_DetectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_relevant_scenarios_detected = /** @type {((inputs: Negotiation_Relevant_Scenarios_DetectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Relevant_Scenarios_DetectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_relevant_scenarios_detected(inputs)
	if (locale === "fr") return fr_negotiation_relevant_scenarios_detected(inputs)
	if (locale === "es") return es_negotiation_relevant_scenarios_detected(inputs)
	if (locale === "it") return it_negotiation_relevant_scenarios_detected(inputs)
	if (locale === "nl") return nl_negotiation_relevant_scenarios_detected(inputs)
	if (locale === "pl") return pl_negotiation_relevant_scenarios_detected(inputs)
	if (locale === "fi") return fi_negotiation_relevant_scenarios_detected(inputs)
	if (locale === "da") return da_negotiation_relevant_scenarios_detected(inputs)
	if (locale === "sv") return sv_negotiation_relevant_scenarios_detected(inputs)
	return en_negotiation_relevant_scenarios_detected(inputs)
});